import { render } from "./OwnHotels.vue?vue&type=template&id=bd37b7c4&scoped=true"
import script from "./OwnHotels.vue?vue&type=script&lang=js"
export * from "./OwnHotels.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./OwnHotels.vue?vue&type=style&index=1&id=bd37b7c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd37b7c4"]])

export default __exports__